function LogError(...args)
{
    Rollbar.error(...args);
};

export default LogError;